<div ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation">
  <div ng-switch-when="sl">
    <div ng-include="'orders/term-deposit-slo.tpl.html'"></div>
  </div>
  <div ng-switch-default>
    <div ng-include="'orders/term-deposit-other.tpl.html'"></div>
  </div>
</div>
